export enum WidgetTone {
  DEFAULT = '',
  DARK = 'dark',
  ACCENT = 'accent',
}

export type PeakHourModel = {
  hour: number
  fillRate: number
}

export type PeakWindowModel = {
  from: number
  to: number
}

export type PeakHoursWidget = {
  hours: PeakHourModel[]
  peakWindow: PeakWindowModel
  maximumFillRate: number
}

export type WidgetDataResult<T> = {
  data: T | null
  loading: boolean
  error: string | null
  refetch?: () => void | Promise<void>
  resetState?: () => void
}

export type NextSessionWidget = {
  courtName?: string
  bookingStartTime: string
  bookingEndTime?: string
}

export enum LockerStatus {
  OPEN = 'OPEN',
  CLOSED = 'CLOSED',
}

export type LockerWidget = {
  number: number
  code: string
  status: LockerStatus
}

export type StatisticWidget = {
  value: number
  changePercentage: number | null
}

/** Prepaid minutes across the customer's active, non-expired passes. */
export type RemainingMinutesWidget = {
  activePassesNumber: number
  availableMinutes: number
  totalMinutes: number
}
